import * as Yup from "yup";

interface IDocumentOfTitle extends Yup.MixedSchema {
  description: string;
  ownedPart: string;
  SNR: string;
  nameOfHousing: string;
  ninForHousingCompany: string;
  estimatedValue: string;
  valuationAmount: string;

}

const DocumentOfTitleSchema = Yup.object<IDocumentOfTitle>().shape({
  description: Yup.string().required(
    "US.COLLECTION.VALIDATIONS:REQUIRED.DESCRIPTION_IS_REQUIRED"
  ),
  nameOfHousing: Yup.string().required(
    "US.COLLECTION.VALIDATIONS:REQUIRED.NAME_OF_HOUSING_COMPANY_IS_REQUIRED"
  ),
  ninForHousingCompany: Yup.string().required(
    "US.COLLECTION.VALIDATIONS:REQUIRED.NIN_OF_HOUSING_COMPANY_IS_REQUIRED"
  ),
  estimatedValue: Yup.string()
  .test(
    "estimatedValue",
    "US.COLLECTION.VALIDATIONS:REQUIRED.ESTIMATED_VALUE_MUST_BE_POSITIVE",
    (val: any) => {
      return val >= 0;
    }
  ),
  valuationAmount: Yup.string()
  .test(
    "valuationAmount",
    "US.COLLECTION.VALIDATIONS:REQUIRED.VALUATION_AMOUNT_MUST_BE_POSITIVE",
    (val: any) => {
      return val >= 0;
    }
  ),
  postalArea: Yup.string()
    .nullable()
    .typeError(
      "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD",
    )
    .when(["postalCode"], {
      is: (postalCode) => {
        postalCode = typeof postalCode == "undefined" ? "" : postalCode;
        return postalCode?.toString().length !== 0;
      },
      then: Yup.string()
        .required(
          "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD",
        )
        .test(
          "zipNameDigit",
          "US.COLLECTION.VALIDATIONS:REQUIRED.PLEASE_ADD_A_VALID_VALUE_INTO_THE_FIELD",
          (val: any) => {
            let value = typeof val == "undefined" ? "" : val;
            return !/^\d+$/.test(value);
          },
        ),
    }),
});

export default DocumentOfTitleSchema;
